const React = require('react');

const { withReq } = require('app/www/components/contexts/Req');
const { withExperiments } = require('app/www/components/contexts/Experiments');

const Global = require('app/www/components/blocks/Global/Global');
const Ua = require('app/www/components/blocks/Ua/Ua');
const AdFox = require('app/www/components/blocks/AdFox/AdFox');

const EXPERIMENT_NAME = 'new_ads_format';

class FullScreenAd extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { experiments } = this.props;
        const isExperiment = experiments.isExperiment(EXPERIMENT_NAME);

        if (!isExperiment) {
            return null;
        }

        const AdFoxProps = Ua.isTouchPhone ? Global.adFox.fullscreen_touch : Global.adFox.fullscreen;

        return (
            <div>
                <AdFox {...AdFoxProps} />
            </div>
        );
    }
}

module.exports = withReq(withExperiments(FullScreenAd));
